import type { ToolbarConfigItem } from 'ckeditor5';

const defaultToolbarItems: ToolbarConfigItem[] = [
	'undo',
	'redo',
	'|',
	'heading',
	'bold',
	'italic',
	'underline',
	'|',
	'link',
	'blockQuote',
	'code',
	'|',
	'bulletedList',
	'numberedList',
	'|',
	'outdent',
	'indent',
	'|',
	'mediaEmbed',
	'insertImage',
	'attachFile',
];

export { defaultToolbarItems };
